<template>
  <div class="map-container">
    <!-- <div class="header">
      <h1>百度地图GL集成示例</h1>
      <p>使用Vue2动态加载百度地图GL资源，支持3D视图和高级交互功能</p>
    </div> -->
    
    <div class="map-controls">
      <div>
  <el-input 
    placeholder="请输入用户名或表号搜索" 
    size="medium"  
    class="input-with-select"
    v-model="searchKeyword"
    @keyup.enter.native="handleSearch"
    clearable>
    <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
  </el-input>
</div>
      <!-- <button class="control-btn" @click="resetView">重置视图</button> -->
      <button class="control-btn" @click="toggle3D">{{ is3D ? '关闭3D' : '开启3D' }}</button>
    </div>
    
    <div class="map-wrapper">
      <!-- <div class="info-panel">
        <h3>地图信息</h3>
        <p>中心点: {{ center.lng.toFixed(4) }}, {{ center.lat.toFixed(4) }}</p>
        <p>缩放级别: {{ zoom }}</p>
        <p>倾斜角度: {{ tilt.toFixed(1) }}°</p>
        <p>旋转角度: {{ rotation.toFixed(1) }}°</p>
        <p>标记数量: {{ markers.length }}</p>
      </div> -->
      <div ref="mapContainer" id="container" class="map-element"></div>
    </div>
    
    <!-- <div class="map-tips">
      <div class="tip">提示：按住鼠标右键控制地图旋转，滚轮调整倾斜角度</div>
    </div> -->
  </div>
</template>
<script>
import { getLatitude } from '@/api/ksharge'
export default {
  name: 'BaiduMapGL',
  props: {
    ak: {
      type: String,
      default: 'AHCjrqjx80mVPwDgAcHp8vMb9oJVqIHo'  // 使用您提供的AK
    },
    initialCenter: {
      type: Object,
      default: () => ({ lng: 104.0, lat: 35.0 })  // 中国中心点
    },
    initialZoom: {
      type: Number,
      default: 5  // 显示整个中国的缩放级别
    },
    enableScrollWheelZoom: {
      type: Boolean,
      default: true
    },
    //  设备数据列表，格式：[{longitude, latitude, name, DeviceStatus}, ...]
    deviceList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      map: null,
      BMapGL: null,
      center: this.initialCenter,
      zoom: this.initialZoom,
      is3D: false,
      tilt: 0,
      rotation: 0, 
      markers: [], // 存储标记对象
      markerData: {}, // 存储标记对应的设备数据 {markerId: deviceData}
      infoWindow: null,      
      mapLoaded: false,
      isUpdatingFromMap: false, // 标志：是否正在从地图事件更新，防止无限循环
      searchKeyword: '', // 搜索关键词
      waterMeterList: [], // 存储从接口获取的水表数据
      loading: false, // 加载状态
      cityCentered: false, // 是否已按首条数据城市定位
      boundaryOverlays: [] // 行政区边界覆盖物
    }
  },
  computed: {
    // 合并props和接口数据，优先使用props，其次使用接口数据
    finalDeviceList() {
      if (this.deviceList && this.deviceList.length > 0) {
        return this.deviceList; 
      }
      // 将接口返回的水表数据转换为设备列表格式
      return this.waterMeterList.map(item => ({
        longitude: item.longitude,
        latitude: item.latitude,
        name: item.meter_id || item.username || '未知',
        DeviceStatus: item.online_status || '未知',
        // 保留原始数据用于信息窗口显示
        originalData: item
      }));
    }
  },
  mounted() {
    this.loadBaiduMapGLResources();
    // 加载完成后获取水表数据
    this.fetchWaterMeterData();
  },
  beforeDestroy() {
    // 清除所有标记
    this.clearMarkers();
    
    // 清理地图资源
    if (this.map) {
      this.map.destroy();
    }
    
    // 移除添加的样式
    const links = document.querySelectorAll('link[href="/bmap.css"]');
    links.forEach(link => link.remove());
  },
  methods: {
    loadBaiduMapGLResources() {
      // 检查是否已加载
      if (window.BMapGL) {
        this.BMapGL = window.BMapGL;
        this.initMap();
        return;
      }
      
      // 动态加载百度地图GL资源
      this.loadCSS();
      this.loadScript();
    },
    loadCSS() {
      const cssId = 'baidu-map-gl-css';
      if (document.getElementById(cssId)) return;
      
      const link = document.createElement('link');
      link.id = cssId;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      // 使用本地资源，避免跨域问题
      link.href = '/bmap.css';
      document.head.appendChild(link);
    },
    loadScript() {
      const scriptId = 'baidu-map-gl-script';
      if (document.getElementById(scriptId)) return;
      
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'text/javascript';
      
      // 生成时间戳参数
      const timestamp = new Date().getTime();
      // 使用 https 协议，避免跨域问题
      script.src = `https://api.map.baidu.com/getscript?type=webgl&v=1.0&ak=${this.ak}&services=&t=${timestamp}`;
      
      script.onload = () => {
        this.BMapGL = window.BMapGL;
        this.initMap();
      };
      script.onerror = (error) => {
        console.error('百度地图GL加载失败:', error);
        this.$message.error('百度地图资源加载失败，请检查网络连接');
      };
      document.head.appendChild(script);
    },
    initMap() {
      // 初始化地图
      this.map = new this.BMapGL.Map(this.$refs.mapContainer);
      
      // 确保 center 有默认值
      if (!this.center || !this.center.lng || !this.center.lat) {
        this.center = { lng: 104.0, lat: 35.0 };
      }
      
      // 设置中心点和缩放级别
      const point = new this.BMapGL.Point(this.center.lng, this.center.lat);
      this.map.centerAndZoom(point, this.zoom);
      
      // 设置最小和最大缩放级别
      this.map.setMinZoom(4);
      this.map.setMaxZoom(18);
      
      // 启用鼠标滚轮缩放
      if (this.enableScrollWheelZoom) {
        console.log(this.enableScrollWheelZoom,'this.enableScrollWheelZoom')
        this.map.enableScrollWheelZoom();
      }
      
      // 启用键盘操作
      this.map.enableKeyboard();
      
      // 启用连续缩放
      this.map.enableContinuousZoom();
      
      // 启用惯性拖拽
      this.map.enableInertialDragging();
      
      // 添加地图控件
      this.addMapControls();
      
      // 添加事件监听
      this.addEventListeners();
      
      // 等待地图加载完成后再设置边界
      this.map.addEventListener('tilesloaded', () => {
        this.setChinaBounds();
        // 地图加载完成后添加标记点
        this.addMarkers();
        // 如果已有数据，尝试按首条坐标所在城市定位
        this.centerToFirstCity();
      });
      
      // 触发ready事件
      this.$emit('ready', this.map);
      this.mapLoaded = true;
    },
    setChinaBounds() {
      try {
        // 设置地图边界，限制只显示中国范围
        // 中国边界范围：经度 73°E - 135°E，纬度 18°N - 54°N
        const sw = new this.BMapGL.Point(73, 18);  // 西南角（左下）
        const ne = new this.BMapGL.Point(135, 54);  // 东北角（右上）
        const bounds = new this.BMapGL.Bounds(sw, ne);
        
        // 使用 setViewport 限制地图显示范围
        if (this.map && this.map.setViewport) {
          this.map.setViewport([bounds]);
        }
      } catch (error) {
        console.warn('设置地图边界失败:', error);
        // 如果 setViewport 失败，使用拖拽限制来替代
        this.restrictMapToChina();
      }
    },
    restrictMapToChina() {
      // 通过监听拖拽事件来限制地图范围
      if (!this.map) return;
      
      // 中国边界范围
      const minLng = 73;
      const maxLng = 135;
      const minLat = 18;
      const maxLat = 54;
      
      this.map.addEventListener('moveend', () => {
        const center = this.map.getCenter();
        if (center) {
          let newLng = center.lng;
          let newLat = center.lat;
          let needAdjust = false;
          
          if (newLng < minLng) {
            newLng = minLng;
            needAdjust = true;
          } else if (newLng > maxLng) {
            newLng = maxLng;
            needAdjust = true;
          }
          
          if (newLat < minLat) {
            newLat = minLat;
            needAdjust = true;
          } else if (newLat > maxLat) {
            newLat = maxLat;
            needAdjust = true;
          }
          
          if (needAdjust) {
            const point = new this.BMapGL.Point(newLng, newLat);
            this.map.panTo(point);
          }
        }
      });
    },
    addMapControls() {
      // 百度地图GL控件添加
      // 注意：某些版本的百度地图GL可能不支持这些控件，或者使用方式不同
      
      // 检查 BMapGL 是否已加载
      if (!this.BMapGL || !this.map) {
        return;
      }
      
      // 尝试添加控件，如果失败则跳过
      const controls = ['Zoom', 'Scale', 'Copyright', 'MapType'];
      
      controls.forEach(controlName => {
        try {
          const ControlClass = this.BMapGL[controlName];
          if (!ControlClass) {
            return; // 控件不存在，跳过
          }
          
          // 检查是否是构造函数（使用更严格的方式）
          // 通过检查是否有 prototype 和 constructor 属性来判断
          const isConstructor = typeof ControlClass === 'function' && 
                                ControlClass.prototype && 
                                ControlClass.prototype.constructor === ControlClass;
          
          if (isConstructor) {
            // 是构造函数，尝试实例化
            try {
              const control = new ControlClass();
              if (control && typeof this.map.addControl === 'function') {
                this.map.addControl(control);
              }
            } catch (e) {
              // 实例化失败，跳过该控件
              console.debug(`无法实例化${controlName}控件:`, e.message);
            }
          } else {
            // 不是构造函数，可能是静态对象或配置对象
            // 跳过，因为 addControl 通常需要控件实例
            console.debug(`${controlName}不是构造函数，跳过添加`);
          }
        } catch (error) {
          // 控件添加失败不影响地图基本功能
          console.debug(`添加${controlName}控件时出错:`, error.message);
        }
      });
    },
    addEventListeners() {
      // 添加地图点击事件
      this.map.addEventListener('click', (e) => {
        this.onMapClick(e);
      });
      
      // 添加地图移动事件
      this.map.addEventListener('moveend', () => {
        const center = this.map.getCenter();
        if (center && center.lng !== undefined && center.lat !== undefined) {
          // 检查值是否真的改变了，避免不必要的更新
          const newCenter = { lng: center.lng, lat: center.lat };
          if (Math.abs(this.center.lng - newCenter.lng) > 0.000001 || 
              Math.abs(this.center.lat - newCenter.lat) > 0.000001) {
            this.isUpdatingFromMap = true;
            this.center = newCenter;
            this.$nextTick(() => {
              this.isUpdatingFromMap = false;
            });
          }
        }
        const zoom = this.map.getZoom();
        if (zoom !== undefined && zoom !== this.zoom) {
          this.zoom = zoom;
        }
        this.$emit('moveend', this.center, this.zoom);
      });
      
      // 添加缩放事件
      this.map.addEventListener('zoomend', () => {
        this.zoom = this.map.getZoom();
        this.$emit('zoomend', this.zoom);
      });
      
      // 添加倾斜变化事件
      this.map.addEventListener('tiltchange', () => {
        this.tilt = this.map.getTilt();
        this.$emit('tiltchange', this.tilt);
      });
      
      // 添加旋转变化事件
      this.map.addEventListener('headingchange', () => {
        this.rotation = this.map.getHeading();
        this.$emit('rotationchange', this.rotation);
      });
    },
    onMapClick(e) {
      if (e && e.latlng && e.latlng.lng !== undefined && e.latlng.lat !== undefined) {
        this.$emit('click', {
          lng: e.latlng.lng,
          lat: e.latlng.lat
        });
      }
    },
    resetView() {
      // 重置倾斜与旋转
      this.map.setTilt(0);
      this.map.setHeading(0);
      this.tilt = 0;
      this.rotation = 0;
      this.is3D = false;
    },
    toggle3D() {
      this.is3D = !this.is3D;
      if (this.is3D) {
        this.map.setTilt(60);
        this.map.setHeading(45);
      } else {
        this.map.setTilt(0);
        this.map.setHeading(0);
      }
    },
    // 获取水表数据
    async fetchWaterMeterData(searchContent = '') {
      try {
        this.loading = true;
        const token = this.$store.state.print?.goodsForeNo?.token || sessionStorage.getItem('token');
        if (!token) {
          console.warn('缺少 token，无法获取水表数据');
          this.loading = false;
          return;
        }
        
        const params = {
          token: token
        };
        
        // 如果有搜索内容，添加到参数中
        if (searchContent && searchContent.trim()) {
          params.search_content = searchContent.trim();
        }
        
        const res = await getLatitude(params);
        console.log(res, '获取水表数据');
        
          if (res && res.data) {
          let responseData = res.data.status === 'success' && res.data.data ? res.data.data : res.data;
          
          // 确保 responseData 是数组
          if (Array.isArray(responseData)) {
            this.waterMeterList = responseData;
          } else if (responseData && Array.isArray(responseData.data)) {
            this.waterMeterList = responseData.data;
          } else {
            this.waterMeterList = [];
          }
          
          // 数据获取成功后，重新添加标记
          if (this.map && this.mapLoaded) {
            this.addMarkers();
            // 只有在非查询场景下才进行城市定位
            if (!searchContent) {
              this.centerToFirstCity();
            }
          }
        } else {
          this.waterMeterList = [];
        }
      } catch (error) {
        console.error('获取水表数据失败:', error);
        this.$message.error('获取水表数据失败');
        this.waterMeterList = [];
      } finally {
        this.loading = false;
      }
    },

    // 设置默认全国视图
    setDefaultView() {
      const point = new this.BMapGL.Point(104.0, 35.0);
      this.map.centerAndZoom(point, 5);
      this.center = { lng: 104.0, lat: 35.0 };
      this.zoom = 5;
    },
    // 按首条数据所属城市定位视图
    centerToFirstCity(force = false) {
      if (!this.map || !this.BMapGL) return;
      if (!force && this.cityCentered) return;
      const first = this.waterMeterList && this.waterMeterList[0];
      if (!first || !first.longitude || !first.latitude) return;
      const point = new this.BMapGL.Point(first.longitude, first.latitude);
      try {
        const geo = new this.BMapGL.Geocoder();
        geo.getLocation(point, res => {
          const city = res?.addressComponents?.city || res?.addressComponents?.province;
          if (city) {
            this.map.centerAndZoom(city, 8);
            this.addCityBoundary(city);
          } else {
            // 若无法解析城市，退回按点缩放
            this.map.centerAndZoom(point, 12);
          }
          const c = this.map.getCenter();
          this.center = c ? { lng: c.lng, lat: c.lat } : { lng: first.longitude, lat: first.latitude };
          this.zoom = this.map.getZoom();
          this.cityCentered = true;
        });
      } catch (e) {
        // geocoder 不可用时，直接按点居中
        this.map.centerAndZoom(point, 12);
        this.center = { lng: first.longitude, lat: first.latitude };
        this.zoom = 12;
        this.cityCentered = true;
      }
    },
    // 根据城市名称绘制行政区边界
    addCityBoundary(cityName) {
      if (!cityName || !this.map) return;
      // 清理旧边界
      this.clearBoundaryOverlays();
      const Boundary = (window.BMap && window.BMap.Boundary) || (this.BMapGL && this.BMapGL.Boundary);
      if (!Boundary) {
        console.warn('边界接口不可用');
        return;
      }
      const bdary = new Boundary();
      bdary.get(cityName, rs => {
        const boundaries = rs && rs.boundaries ? rs.boundaries : [];
        if (!boundaries.length) {
          console.warn('未获取到行政区边界:', cityName);
          return;
        }
        boundaries.forEach(pathStr => {
          try {
            // 将坐标字符串转换为点数组
            const pts = pathStr.split(';')
              .map(str => str.trim())
              .filter(Boolean)
              .map(str => {
                const [lng, lat] = str.split(',').map(Number);
                return new this.BMapGL.Point(lng, lat);
              });
            if (!pts.length) return;
            const polygon = new this.BMapGL.Polygon(pts, {
              strokeWeight: 2,
              strokeColor: '#DD001B',
              strokeOpacity: 0.9,
              fillOpacity: 0.1,
              fillColor: '#FF7F7F'
            });
            this.map.addOverlay(polygon);
            this.boundaryOverlays.push(polygon);
          } catch (err) {
            console.warn('绘制边界失败:', err);
          }
        });
      });
    },
    // 清理行政区边界覆盖物
    clearBoundaryOverlays() {
      if (!this.map || !this.boundaryOverlays.length) return;
      this.boundaryOverlays.forEach(ov => {
        try {
          this.map.removeOverlay(ov);
        } catch (e) {}
      });
      this.boundaryOverlays = [];
    },
      // 添加标记点
    addMarkers() {
      if (!this.map || !this.BMapGL) {
        return;
      }
      
      const deviceList = this.finalDeviceList;
      if (!deviceList || deviceList.length === 0) {
        return;
      }
      
      // 清除现有标记
      this.clearMarkers();
      
      // 遍历设备列表，添加标记
      deviceList.forEach((device, index) => {
        // 只有当有经纬度时才添加标记
        if (device && device.longitude && device.latitude) {
          this.addMarker(device, index);
        }
      });
    },
    // 添加单个标记点
    addMarker(device, index) {
      try {
        if (!this.BMapGL || !this.map) {
          return;
        }
        
        const point = new this.BMapGL.Point(device.longitude, device.latitude);
        
        // 创建标记图标 - 使用项目中的图片或默认图标
        let marker;
        if (this.BMapGL.Marker) {
          try {
            // 使用项目中的图片作为标记图标
            // 使用相对路径引用图片文件
            let iconUrl = '';
            try {
              // 使用require引入项目中的图片
              // 路径：从top2目录到img目录
              iconUrl = require('../img/ylxicon.png');
            } catch (e) {
              // 如果本地图片不存在，使用百度地图默认红色标记
              iconUrl = 'http://api.map.baidu.com/images/marker_red.png';
            }
            
            const icon = new this.BMapGL.Icon(
              iconUrl,
              new this.BMapGL.Size(25, 34),
              {
                anchor: new this.BMapGL.Size(12, 34)
              }
            );
            marker = new this.BMapGL.Marker(point, {
              icon: icon
            });
          } catch (e) {
            // 如果图标创建失败，使用默认标记
            try {
              marker = new this.BMapGL.Marker(point);
            } catch (err) {
              console.warn('创建标记失败:', err);
              return;
            }
          }
        } else {
          console.warn('BMapGL.Marker 不存在');
          return;
        }
        
        // 将标记添加到地图
        this.map.addOverlay(marker);
        
        // 存储标记和设备数据的关联
        const markerId = `marker_${index}_${Date.now()}`;
        this.markerData[markerId] = device;
        marker.markerId = markerId;
        marker.deviceData = device; // 直接存储设备数据到标记对象上
        
        // 添加点击事件
        marker.addEventListener('click', () => {
          this.onMarkerClick(marker, point, device);
        });
        
        // 保存标记引用
        this.markers.push(marker);
      } catch (error) {
        console.error('添加标记失败:', error, device);
      }
    },
    // 清除所有标记
    clearMarkers() {
      if (this.map && this.markers.length > 0) {
        this.markers.forEach(marker => {
          try {
            this.map.removeOverlay(marker);
          } catch (error) {
            console.warn('移除标记失败:', error);
          }
        });
        this.markers = [];
        this.markerData = {};
      }
    },
    onMarkerClick(marker, point, device) {
      // 创建信息窗口
      if (!this.infoWindow) {
        this.infoWindow = new this.BMapGL.InfoWindow('', {
          width: 240,
          height: 'auto',
          maxHeight: 300
        });
      }
      
      // 获取原始数据（如果存在）
      const originalData = device.originalData || device;
      
      // 构建信息窗口内容
      let content = '<div style="padding: 8px; font-size: 12px; line-height: 1.4;">';
      content += '<h4 style="margin: 0 0 8px 0; color: #333; font-size: 14px; border-bottom: 1px solid #eee; padding-bottom: 6px;">水表信息</h4>';
      
      // 表号
      if (originalData.meter_id) {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">表号：</strong><span style="color: #333;">${originalData.meter_id}</span></p>`;
      }
      
      // 用户名
      if (originalData.username !== undefined && originalData.username !== null && originalData.username !== '') {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">用户名：</strong><span style="color: #333;">${originalData.username}</span></p>`;
      }
      
      // 手机号
      if (originalData.phone !== undefined && originalData.phone !== null && originalData.phone !== '') {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">手机号：</strong><span style="color: #333;">${originalData.phone}</span></p>`;
      }
      
      // 余额
      if (originalData.balance !== undefined && originalData.balance !== null) {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">余额：</strong><span style="color: #333;">${originalData.balance}</span></p>`;
      }
      
      // 地址
      if (originalData.address !== undefined && originalData.address !== null && originalData.address !== '') {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">地址：</strong><span style="color: #333;">${originalData.address}</span></p>`;
      }
      
      // 在线状态
      if (originalData.online_status !== undefined && originalData.online_status !== null && originalData.online_status !== '') {
        const statusColor = originalData.online_status === '在线' ? '#67C23A' : '#F56C6C';
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">在线状态：</strong><span style="color: ${statusColor};">${originalData.online_status}</span></p>`;
      }
      
      // 阀门状态
      if (originalData.valve_status !== undefined && originalData.valve_status !== null && originalData.valve_status !== '') {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">阀门状态：</strong><span style="color: #333;">${originalData.valve_status}</span></p>`;
      }
      
      // 经纬度
      content += `<p style="margin: 4px 0;"><strong style="color: #666;">经度：</strong><span style="color: #333;">${point.lng.toFixed(6)}</span></p>`;
      content += `<p style="margin: 4px 0;"><strong style="color: #666;">纬度：</strong><span style="color: #333;">${point.lat.toFixed(6)}</span></p>`;
      
      // 坐标信息创建时间
      if (originalData.create_time) {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">创建时间：</strong><span style="color: #333;">${originalData.create_time}</span></p>`;
      }
      
      // 坐标信息更新时间
      if (originalData.update_time) {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">更新时间：</strong><span style="color: #333;">${originalData.update_time}</span></p>`;
      }
      
      content += '</div>';
      
      this.infoWindow.setContent(content);
      this.map.openInfoWindow(this.infoWindow, point);
      
      // 触发点击事件
      this.$emit('marker-click', {
        marker,
        point: {
          lng: point.lng,
          lat: point.lat
        },
        device: originalData
      });
    },
    setCenter(lng, lat) {
      const point = new this.BMapGL.Point(lng, lat);
      this.map.panTo(point);
      this.center = { lng, lat };
    },
    setZoom(zoom) {
      this.map.setZoom(zoom);
      this.zoom = zoom;
    },
    // 聚焦首条结果并打开信息窗口（查询后调用）
    focusAndOpenFirst() {
      if (!this.map || !this.BMapGL) return;
      if (!this.waterMeterList || this.waterMeterList.length === 0) return;
      if (!this.markers || this.markers.length === 0) return;
      
      const first = this.waterMeterList[0];
      const marker = this.markers[0];
      
      if (!first || !first.longitude || !first.latitude) return;
      
      const point = new this.BMapGL.Point(first.longitude, first.latitude);
      
      // 放大到 18 级
      this.map.centerAndZoom(point, 18);
      this.center = { lng: first.longitude, lat: first.latitude };
      this.zoom = 18;
      
      // 获取设备数据（优先使用 marker 上的 deviceData，否则使用 first）
      const deviceData = marker.deviceData || marker.originalData || first;
      
      // 等待地图动画完成后再打开信息窗口
      setTimeout(() => {
        this.onMarkerClick(marker, point, deviceData);
      }, 300);
    },
    // 搜索设备
    handleSearch() {
      const keyword = this.searchKeyword ? this.searchKeyword.trim() : '';
      const doSearch = async () => {
        await this.fetchWaterMeterData(keyword);
        // 若有关键词且返回结果，等待标记添加完成后再聚焦首条并打开信息窗口
        if (keyword && this.waterMeterList && this.waterMeterList.length > 0) {
          // 等待标记添加完成
          this.$nextTick(() => {
            // 再等待一下确保标记已完全渲染
            setTimeout(() => {
              if (this.markers && this.markers.length > 0) {
                this.focusAndOpenFirst();
              }
            }, 100);
          });
        }
      };
      doSearch();
    },
    // 定位到设备并打开信息弹框
    focusOnDevice(device) {
      if (!this.map || !this.BMapGL || !device) {
        return;
      }
      
      const point = new this.BMapGL.Point(device.longitude, device.latitude);
      
      // 设置标志，防止触发无限循环
      this.isUpdatingFromMap = true;
      
      // 放大到合适的缩放级别（15级适合查看单个设备）
      this.map.centerAndZoom(point, 15);
      
      // 更新中心点和缩放级别
      this.center = { lng: device.longitude, lat: device.latitude };
      this.zoom = 15;
      
      // 延迟打开信息弹框，确保地图已经定位完成
      this.$nextTick(() => {
        this.isUpdatingFromMap = false;
        
        // 等待地图动画完成后再打开信息弹框
        setTimeout(() => {
          // 查找对应的标记
          const marker = this.markers.find(m => {
            return m.deviceData && 
                   m.deviceData.longitude === device.longitude && 
                   m.deviceData.latitude === device.latitude;
          });
          
          // 打开信息弹框
          if (marker) {
            // 如果找到了标记，使用标记的点击事件
            this.onMarkerClick(marker, point, device);
          } else {
            // 如果没有找到标记，直接打开信息弹框
            this.showDeviceInfo(point, device);
          }
        }, 500); // 等待地图动画完成（500ms足够）
      });
    },
    // 显示设备信息（不依赖标记）
    showDeviceInfo(point, device) {
      // 创建信息窗口
      if (!this.infoWindow) {
        this.infoWindow = new this.BMapGL.InfoWindow('', {
          width: 240,
          height: 'auto',
          maxHeight: 300
        });
      }
      
      // 获取原始数据（如果存在）
      const originalData = device.originalData || device;
      
      // 构建信息窗口内容
      let content = '<div style="padding: 8px; font-size: 12px; line-height: 1.4;">';
      content += '<h4 style="margin: 0 0 8px 0; color: #333; font-size: 14px; border-bottom: 1px solid #eee; padding-bottom: 6px;">水表信息</h4>';
      
      // 表号
      if (originalData.meter_id) {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">表号：</strong><span style="color: #333;">${originalData.meter_id}</span></p>`;
      }
      
      // 用户名
      if (originalData.username !== undefined && originalData.username !== null && originalData.username !== '') {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">用户名：</strong><span style="color: #333;">${originalData.username}</span></p>`;
      }
      
      // 手机号
      if (originalData.phone !== undefined && originalData.phone !== null && originalData.phone !== '') {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">手机号：</strong><span style="color: #333;">${originalData.phone}</span></p>`;
      }
      
      // 余额
      if (originalData.balance !== undefined && originalData.balance !== null) {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">余额：</strong><span style="color: #333;">${originalData.balance}</span></p>`;
      }
      
      // 地址
      if (originalData.address !== undefined && originalData.address !== null && originalData.address !== '') {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">地址：</strong><span style="color: #333;">${originalData.address}</span></p>`;
      }
      
      // 在线状态
      if (originalData.online_status !== undefined && originalData.online_status !== null && originalData.online_status !== '') {
        const statusColor = originalData.online_status === '在线' ? '#67C23A' : '#F56C6C';
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">在线状态：</strong><span style="color: ${statusColor};">${originalData.online_status}</span></p>`;
      }
      
      // 阀门状态
      if (originalData.valve_status !== undefined && originalData.valve_status !== null && originalData.valve_status !== '') {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">阀门状态：</strong><span style="color: #333;">${originalData.valve_status}</span></p>`;
      }
      
      // 经纬度
      content += `<p style="margin: 4px 0;"><strong style="color: #666;">经度：</strong><span style="color: #333;">${point.lng.toFixed(6)}</span></p>`;
      content += `<p style="margin: 4px 0;"><strong style="color: #666;">纬度：</strong><span style="color: #333;">${point.lat.toFixed(6)}</span></p>`;
      
      // 坐标信息创建时间
      if (originalData.create_time) {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">创建时间：</strong><span style="color: #333;">${originalData.create_time}</span></p>`;
      }
      
      // 坐标信息更新时间
      if (originalData.update_time) {
        content += `<p style="margin: 4px 0;"><strong style="color: #666;">更新时间：</strong><span style="color: #333;">${originalData.update_time}</span></p>`;
      }
      
      content += '</div>';
      
      this.infoWindow.setContent(content);
      this.map.openInfoWindow(this.infoWindow, point);
    }
  },
  watch: {
    center(newVal, oldVal) {
      // 如果正在从地图事件更新，跳过watch处理，防止无限循环
      if (this.isUpdatingFromMap) {
        return;
      }
      
      // 检查值是否真的改变了
      if (oldVal && newVal && 
          Math.abs(oldVal.lng - newVal.lng) < 0.000001 && 
          Math.abs(oldVal.lat - newVal.lat) < 0.000001) {
        return;
      }
      
      if (this.map && this.mapLoaded && newVal && newVal.lng !== undefined && newVal.lat !== undefined) {
        const point = new this.BMapGL.Point(newVal.lng, newVal.lat);
        // 使用 nextTick 确保不会立即触发 moveend
        this.$nextTick(() => {
          if (!this.isUpdatingFromMap) {
            this.map.panTo(point);
          }
        });
      }
    },
    zoom(newVal, oldVal) {
      // 检查值是否真的改变了
      if (oldVal === newVal) {
        return;
      }
      
      if (this.map && this.mapLoaded && newVal !== undefined) {
        // 使用 nextTick 确保不会立即触发 zoomend
        this.$nextTick(() => {
          this.map.setZoom(newVal);
        });
      }
    },
    deviceList: {
      handler(newVal) {
        // 当设备列表变化时，重新添加标记点
        if (this.map && this.mapLoaded) {
          this.addMarkers();
        }
      },
      deep: true,
      immediate: false
    },
    waterMeterList: {
      handler(newVal) {
        // 当水表列表变化时，重新添加标记点
        if (this.map && this.mapLoaded) {
          this.addMarkers();
          // 如果有新数据且当前没有定位，则定位到第一条
          if (newVal && newVal.length > 0 && this.markers.length === 0) {
            this.$nextTick(() => {
              this.centerToFirstMarker();
            });
          }
        }
      },
      deep: true,
      immediate: false
    }
  }
}
</script>

<style lang="less" scoped>
.el-select .el-input {
    width: 130px;
  }
.map-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.header {
  text-align: center;
  margin-bottom: 20px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  h1 {
    font-size: 28px;
    margin-bottom: 10px;
    color: #333;
  }
  
  p {
    color: #666;
    font-size: 16px;
  }
}
.map-controls {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.control-btn {
  padding: 10px 15px;
  background: #4a76a9;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
  font-size: 14px;
  
  &:hover {
    background: #3a5f8a;
  }
}
.map-wrapper {
  position: relative;
  flex: 1;
  height: 600px;
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.map-element {
  width: 100%;
  height: 100%;
}
.info-panel {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1000;
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  min-width: 200px;
  
  h3 {
    margin-bottom: 10px;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 5px;
  }
  
  p {
    margin-bottom: 5px;
    font-size: 14px;
    color: #666;
  }
}
.map-tips {
  text-align: center;
  margin-top: 20px;
}
.tip {
  display: inline-block;
  background: white;
  padding: 10px 20px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #666;
  font-size: 14px;
}
@media (max-width: 768px) {
  .map-wrapper {
    height: 400px;
  }
  .header h1 {
    font-size: 24px;
  }
  .info-panel {
    position: relative;
    top: 0;
    right: 0;
    margin-bottom: 10px;
  }
  .map-controls {
    justify-content: center;
  }
}
</style>